import { FC, Fragment } from 'react';

import ManualSelect from './selects/ManualSelect';
import { IAttributionItem } from '../../../../../../app/types/filter';


interface IAttributionProps {
    items: IAttributionItem[]
    isDashboard?: boolean;
    setBtnDisabled?: (value: boolean) => void
}

const Attribution: FC<IAttributionProps> = ({ items, setBtnDisabled, isDashboard }) => {
    return (
        <>
            {
                items.map((item, index) => (
                    <span data-help-id={`params-${item.id}`} key={index}>
                        <ManualSelect
                            setBtnDisabled={setBtnDisabled}
                            isDashboardAttributes={Boolean(isDashboard)}
                            id={item.id}
                            name={item.name}
                            selectValues={item.selectValues}
                            description={item.description}
                            icon={item.icon}
                        />
                    </span>
                ))
            }
        </>
    );
};

export default Attribution;
